import type { TicketCta, TourEvent } from './event.types';

/**
 * Copy honesto de los estados de venta (ADR-003 §3). El mockup de Cancun ya
 * rotula "ENTRADAS: PROXIMAMENTE": no es un parche, es el diseno aprobado.
 */
const COPY = {
  comingSoon: {
    label: 'Entradas: próximamente',
    note: 'La venta todavía no está abierta. Anunciaremos aquí la fecha de apertura.',
  },
  soldOut: {
    label: 'Entradas agotadas',
    note: 'Ya no quedan lugares para este destino.',
  },
  onSale: 'Reservar mi lugar',
  /* Funes no vende entrada: se reserva escribiendo al organizador. El rotulo lo
   * dice, porque un boton que promete una compra y abre un chat es una promesa
   * rota, aunque el enlace funcione. */
  whatsapp: 'Reservar por WhatsApp',
} as const;

/**
 * UNICA forma valida de pintar el CTA de compra de un destino.
 *
 * Devuelve una union discriminada: cuando no hay ficha de venta, el resultado
 * NI SIQUIERA TIENE campo `href`. Es imposible, por tipos, renderizar un enlace
 * roto, un `#`, o un enlace a la home de la plataforma fingiendo ser la ficha.
 *
 * El dia que existan las 5 fichas de Hi.Events basta con poner `ticketUrl` y
 * `salesState: 'on-sale'` en `event.config.ts`. Ninguna pagina cambia.
 */
export function getTicketCta(event: TourEvent): TicketCta {
  switch (event.salesState) {
    case 'on-sale': {
      // El esquema Zod ya garantiza que `on-sale` implica `ticketUrl` no nulo,
      // pero no se confia: si algo lo burlara, se degrada a `coming-soon`,
      // nunca a un enlace vacio.
      if (event.ticketUrl === null) {
        return { kind: 'coming-soon', ...COPY.comingSoon };
      }
      return {
        kind: 'link',
        label: COPY.onSale,
        href: event.ticketUrl,
        isExternal: true,
      };
    }
    case 'whatsapp': {
      // Mismo cinturon que `on-sale`: si faltara la URL, se degrada a
      // `coming-soon` antes que pintar un enlace vacio.
      if (event.ticketUrl === null) {
        return { kind: 'coming-soon', ...COPY.comingSoon };
      }
      return {
        kind: 'link',
        label: COPY.whatsapp,
        href: event.ticketUrl,
        isExternal: true,
      };
    }
    case 'sold-out':
      return { kind: 'sold-out', ...COPY.soldOut };
    case 'coming-soon':
      return { kind: 'coming-soon', ...COPY.comingSoon };
  }
}

/** Ruta interna de un destino dentro de la SPA. Nunca se teclea "/miami". */
export function getEventPath(event: TourEvent): string {
  return event.path;
}

/** Ruta del hub. Todas las paginas de destino vuelven aqui. */
export const TOUR_HUB_PATH = '/';
